<template>
  <v-row justify="end" no-gutters class="fill-height">
    <v-col cols="12" lg="8" class="d-none d-lg-block">
      <div class="login-image"></div>
    </v-col>
    <v-col cols="12" lg="4" class="white d-flex align-center">
      <v-row justify="center">
        <v-col lg="9">
          <div class="text-center">
            <SvgLogo class="mx-auto mb-8" width="390" iconType="StrixLogo" />
            <h1 class="secondary--text font-weight-black text-h4 mb-4">
              {{ $t('portal.login.forgot_password.labels.title') }}
            </h1>
            <p class="secondary--text">
              {{ $t('portal.login.forgot_password.labels.subtitle') }}
            </p>
          </div>

          <v-form ref="form" v-model="valid" @submit.prevent lazy-validation>
            <div class="mb-2">
              <span class="mb-2 input-title text-body-2 inline-block">
                {{
                  $t('portal.login.forgot_password.labels.label_email_input')
                }}
              </span>
              <v-text-field
                v-model="username"
                :rules="emailRules"
                class="rounded-0"
                filled
                required
                dense
                hide-details
                height="48"
                @keyup.enter="submit"
              ></v-text-field>
            </div>

            <p class="text-right">
              <router-link
                class="tertiary--text text-decoration-none text-body-2"
                :to="{ name: 'login' }"
                id="idLoginVolver"
                >{{
                  $t('portal.login.forgot_password.labels.label_back_to_login')
                }}</router-link
              >
            </p>

            <v-alert
              dismissible
              v-model="alert"
              close-icon="mdi-close"
              dark
              transition="fade-transition"
              color="primary"
            >
              <div class="white--text font-weight-bold mb-0">
                {{ $t('portal.login.forgot_password.labels.label_warning') }}
              </div>
              <div class="white--text mb-0">
                {{ alertMessage }}
              </div>
            </v-alert>

            <v-btn
              class="mt-7 text-uppercase text-caption font-weight-bold"
              dark
              color="deepSkyBlue"
              block
              rounded
              height="48"
              :loading="loading"
              @click="submit"
              id="idLoginUsuarioRestablecer"
              >{{
                $t('portal.login.forgot_password.labels.submit_button')
              }}</v-btn
            >
          </v-form>
          <p
            class="text-center mt-3"
            v-if="$t('portal.login.forgot_password.labels.account')"
          >
            <router-link
              class="primary--text text-decoration-none text-body-2"
              :to="{ name: 'register' }"
              >{{
                $t('portal.login.forgot_password.labels.account')
              }}</router-link
            >
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { SvgLogo, magentaOAuth } from '@leapsight/styleguide'
import { mapActions } from 'vuex'
import store from '@/store'
import i18n from '@/plugins/i18n'

export default {
  name: 'Login',
  components: {
    SvgLogo
  },
  beforeRouteEnter(to, from, next) {
    // Si el usuario ya esta logeado lo redirijo al launcher
    store.dispatch('auth/checkTokenIsActive').then(function() {
      if (
        store.getters['auth/isLoggedIn'] &&
        store.getters['auth/tokenValid']
      ) {
        next({ name: 'launcher' })
      } else {
        next()
      }
    })
  },

  data: () => ({
    loading: false,
    valid: false,
    alert: false,
    alertMessage: '',
    username: '',
    emailRules: [
      v => !!v || i18n.t('portal.login.login.rules.email_required'),
      v =>
        /.+@.+\..+/.test(v) || i18n.t('portal.login.login.rules.email_format')
    ]
  }),
  methods: {
    ...mapActions('auth', ['login']),

    submit() {
      if (this.$refs.form.validate()) {
        this.loading = !this.loading

        magentaOAuth
          .changePassword(this.username)
          .then(
            response => {
              if (response.status == 204) {
                this.loading = !this.loading
                this.$router.push({ name: 'verification-link-sent' })
              } else {
                switch (response.data.code) {
                  case 'com.magenta.error.not_found':
                    this.alertMessage = i18n.t(
                      'portal.login.forgot_password.errors.not_found'
                    )
                    this.alert = true
                    break

                  case 'com.magenta.error.user.not_active':
                    this.alertMessage = i18n.t(
                      'portal.login.forgot_password.errors.user_not_active'
                    )
                    this.alert = true
                    break

                  default:
                    this.alertMessage = i18n.t(
                      'portal.login.forgot_password.errors.no_response'
                    )
                    this.alert = true
                    break
                }
                this.loading = !this.loading
              }
            },
            error => {
              return error.response
            }
          )
          .catch(err => {
            console.log(err, 'catch')
          })
      }
    }
  },
  mounted() {
    document.getElementsByClassName('v-text-field__slot')[0].setAttribute("id", "idLoginCorreoRestablecer")
  }
}
</script>
<style scoped>
.input-title {
  color: #007cfd;
  font-size: 0.8rem;
}
.login-image {
  background-image: url('../../assets/bg-login.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-position: 0% 0%;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
